import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Lottie from "lottie-react";

import styles from './index.module.css';

import loadingAnimation from '../../assets/json/animation/loading.json';

function LoadingPage(props) {
  return (
    <div className={styles['wrapper']}>
      <Lottie animationData={loadingAnimation} loop={true} />
    </div>
  );
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LoadingPage);
